<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <modal-tab-employeer :objRS="sendObjRS"/>

    <section>
      <page-header :connectionName="'Lista de Pins'" :showBtn="false" :btnName="''" :btnRoute="''"
                   :css="'container-fluid'"/>

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loadingList"/>

            <!-- Filters -->
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div v-if="!loadingList" class="col-xs-12 col-sm-12 col-md-12 default-box filters">
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="col-xs-12 col-sm-6 col-md -3">
                    <div class="form-group">
                      <label>CompanyId</label>
                      <input v-model="dataSearch.companyId" type="text" class="form-control" name="companyId"
                             placeholder="companyId" required>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Banco</label>
                      <input v-model="dataSearch.connection" type="text" class="form-control" name="connection"
                             placeholder="connection" required>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Pin</label>
                      <input v-model="dataSearch.pin" type="text" class="form-control" name="pin" placeholder="pin">
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <button v-on:click="getList()">Pesquisar</button>
                </div>
              </div>
            </div>

            <!-- No Result -->
            <div v-if="!loadingList && (dataList !== '' && !dataList.length) && !failRequest"
                 class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Sem resultado na pesquisa.</p>
              </div>
            </div>

            <!-- Fail Request -->
            <div v-if="!loadingList && failRequest" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Falha na requisição.</p>
              </div>
            </div>

            <!-- Table -->
            <div v-if="!loadingList && dataList.length" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box orderBy">
                <div class="portlet-title">
                  <div class="caption">
                    <span
                      class="caption-subject font-blue bold uppercase">Quantidade total de pins ({{ dataList.length }})</span>
                  </div>
                </div>

                <button v-on:click="openModal()" class="btn-open-users">Usuários que vão pro MarQTab</button>

                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <table class="table table-hover table-light table-icon">
                      <thead>
                      <tr>
                        <th> ID</th>
                        <th> NOME</th>
                        <th> EMAIL</th>
                        <th> PIN CRIPTOGRAFADO</th>
                        <th> PIN NÃO CRIPTOGRAFADO</th>
                        <th> ATIVO?</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="c in dataList">
                        <td>{{ c.id }}</td>
                        <td>{{ c.userName }}</td>
                        <td>{{ c.email }}</td>
                        <td>{{ c.pin }}</td>
                        <td>{{ c.pinCode }}</td>
                        <td>
                          <span v-if="c.active">SIM</span>
                          <span v-else>NÃO</span>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import modalTabEmployeer from "../../modals/modalTabEmployeer.vue";
import swal from 'sweetalert';

import {
  GET_COMPANY_PIN
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";
import pageHeader from "../../components/default/pageHeader.vue";

export default {
  name: "pin-list",
  components: {
    topMenu,
    pageHeader,
    modalTabEmployeer,
    fullLoading
  },
  data() {
    return {
      sendObjRS: {},
      failRequest: false,
      loadingList: false,
      dataList: '',
      dataSearch: {
        connection: 'AAAA',
        companyId: '',
        pin: ''
      },
    }
  },
  methods: {
    openModal() {
      this.sendObjRS = {
        companyId: this.dataSearch.companyId,
        context: this.dataSearch.connection,
        random: Math.floor(Math.random() * 500)
      };

      $("#modalTabEmployeer").modal();
    },
    getList() {
      if (this.dataSearch.companyId && this.dataSearch.connection) {

        this.loadingList = true;
        let url = GET_COMPANY_PIN;
        url += "?companyId=" + this.dataSearch.companyId;
        url += "&connection=" + this.dataSearch.connection;
        url += "&pin=" + this.dataSearch.pin;

        UTIL_SERVICE.console("URL SEARCH:", url);
        REQUEST_SERVICE.requestContext('GET', url, this.dataSearch.connection).then((response) => {
          UTIL_SERVICE.console("RESULT GET_COMPANY_PIN:", response.data);

          this.dataList = response.data;
          this.loadingList = false;
          this.failRequest = false;
        }).catch((reason) => {
          this.loadingList = false;
          this.failRequest = true;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
      } else {
        swal("Aviso", "Preencha os campos para pesquisar", "error");
      }
    }
  }
}
</script>

<style lang="scss">
.btn-open-users {
  border-radius: 4px !important;
  background-color: #3598dc;
  height: 33px;
  width: auto;
  text-align: center;
  color: #ffffff;
  border: none;
  margin-left: 17px;
  float: right;
  position: absolute;
  right: 16px;
  top: 15px;
  padding: 0 17px;

  &:hover {
    background: #054F91;
  }
}

.vdp-datepicker {
  display: inline-block;
  width: 90%;

  input {
    border: 1px solid #ccc;
    border-radius: 5px;
    height: 34px;
    width: 100%;
    padding: 0 10px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/allCompany/pinList.vue